import {
  hexToRgb
} from 'helpers/colors';

angular.module('shared').factory('ContrastColor', function() {
  return {
    get: function(bgColor, params) {
      var B, C, G, L, R, rgb;
      if (!bgColor) {
        return null;
      }
      rgb = hexToRgb(bgColor);
      if (!rgb) {
        return null;
      }
      R = rgb.r;
      G = rgb.g;
      B = rgb.b;
      C = [R / 255, G / 255, B / 255];
      C.forEach(function(Ci, i) {
        if (Ci <= 0.03928) {
          return C[i] = Ci / 12.92;
        } else {
          return C[i] = ((Ci + 0.055) / 1.055) ** 2.4;
        }
      });
      L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2];
      if (L > 0.6) {
        return (params != null ? params.darkColor : void 0) || '#000';
      } else {
        return '#fff';
      }
    }
  };
});
